import { grey } from "@mui/material/colors";

const defaultStyles = {
  root: {
    "& fieldset.MuiOutlinedInput-notchedOutline": {
      borderRadius: 4,
      borderColor: grey[300],
    },
    "& .MuiInputBase-root": { backgroundColor: "white" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  },
};

export default defaultStyles;
